/* eslint-disable no-console */
import { client } from "./supabase"; // cliente oficial, igual que en getUsers

export const getEmpleados = async (pais) => {
  try {
    const { data, error } = await client
      .from("empleados")
      .select("*")
      .eq("pais", pais)
      .order("apellido", { ascending: true })
      .order("nombre", { ascending: true });
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error("Error en getEmpleados:", error);
    throw error;
  }
};

export const crearEmpleado = async (data) => {
  try {
    console.log("Datos enviados a insert:", data); // temporal para debug
    const { data: result, error } = await client.from("empleados").insert([data]).select();
    if (error) throw error;
    return result;
  } catch (error) {
    console.error("Error en crearEmpleado:", error);
    throw error;
  }
};

export const actualizarEmpleado = async (id, data) => {
  try {
    const { data: result, error } = await client.from("empleados").update(data).eq("id", id).select();
    if (error) throw error;
    return result;
  } catch (error) {
    console.error("Error en actualizarEmpleado:", error);
    throw error;
  }
};

export const getVacacionesEmpleado = async (empleadoId) => {
  try {
    const { data, error } = await client
      .from("vacaciones_empleado")
      .select("*")
      .eq("empleado_id", empleadoId)
      .order("fecha_inicio", { ascending: false });
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error("Error en getVacacionesEmpleado:", error);
    throw error;
  }
};

// Todas las vacaciones del país — para vista de cards en Empleados (no N+1)
export const getVacacionesPais = async (pais) => {
  try {
    const { data, error } = await client
      .from("vacaciones_empleado")
      .select("*, empleados!inner(pais)")
      .eq("empleados.pais", pais)
      .order("fecha_inicio", { ascending: false });
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error("Error en getVacacionesPais:", error);
    throw error;
  }
};

export const agregarVacaciones = async (data) => {
  try {
    const { data: result, error } = await client.from("vacaciones_empleado").insert([data]).select();
    if (error) throw error;
    return result;
  } catch (error) {
    console.error("Error en agregarVacaciones:", error);
    throw error;
  }
};

// Cargar remuneraciones de un empleado
export const getRemuneracionesEmpleado = async (empleadoId) => {
  try {
    const { data, error } = await client
      .from("remuneraciones_empleado")
      .select("*")
      .eq("empleado_id", empleadoId)
      .order("inicio_vigencia", { ascending: true });
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error("Error en getRemuneracionesEmpleado:", error);
    throw error;
  }
};

// Crear nueva remuneración
export const crearRemuneracion = async (data) => {
  try {
    const { data: result, error } = await client.from("remuneraciones_empleado").insert([data]).select();
    if (error) throw error;
    return result;
  } catch (error) {
    console.error("Error en crearRemuneracion:", error);
    throw error;
  }
};

// Actualizar remuneración existente
export const actualizarRemuneracion = async (id, data) => {
  try {
    const { data: result, error } = await client.from("remuneraciones_empleado").update(data).eq("id", id).select();
    if (error) throw error;
    return result;
  } catch (error) {
    console.error("Error en actualizarRemuneracion:", error);
    throw error;
  }
};

// Escala impuesto único Chile 2026 — UTM $71.506 (vigente 2026). Rebajas calculadas
// como múltiplos de UTM → escalan con el valor. TODO futuro: pasar UTM del mes exacto.
const calcularImpuestoUnico = (base) => {
  const UTM = 71506;
  if (base <= 13.5 * UTM) return 0;
  if (base <= 30 * UTM) return Math.max(0, Math.round(base * 0.04 - 0.54 * UTM));
  if (base <= 50 * UTM) return Math.max(0, Math.round(base * 0.08 - 1.74 * UTM));
  if (base <= 70 * UTM) return Math.max(0, Math.round(base * 0.135 - 4.49 * UTM));
  if (base <= 90 * UTM) return Math.max(0, Math.round(base * 0.23 - 11.14 * UTM));
  if (base <= 120 * UTM) return Math.max(0, Math.round(base * 0.304 - 17.8 * UTM));
  if (base <= 310 * UTM) return Math.max(0, Math.round(base * 0.35 - 23.32 * UTM));
  return Math.max(0, Math.round(base * 0.4 - 38.82 * UTM));
};

/**
 * Calcula la liquidación mensual Chile a partir de los datos de remuneración.
 * Fuente de verdad: recibos de sueldo reales (Franco, Nico, Jorge — abril 2026).
 * Cuadra exacto si la remuneración trae bonos_fijo/variable cargados y se pasa
 * el ufDelMes correcto para empleados con Isapre.
 *
 * @param {Object} rem - Remuneración vigente: sueldo_base, bonos_fijo, bonos_variable,
 *                       afp_cap_individual_pct, afp_comision_pct, salud_tipo, salud_isapre_uf.
 * @param {number} ufDelMes - Valor UF del mes (necesario para Isapre).
 * @param {number} descuentosVarios - Anticipos, préstamos u otros descuentos no legales.
 */
export const calcularLiquidacionChile = (rem, ufDelMes = 0, descuentosVarios = 0) => {
  const IMM = 539000;
  const sueldoBase = Number(rem.sueldo_base) || 0;
  const bonosFijo = Number(rem.bonos_fijo) || 0;
  const bonosVariable = Number(rem.bonos_variable) || 0;
  const gratificacion = Math.min(Math.round(sueldoBase * 0.25), Math.round((4.75 * IMM) / 12));
  // Imponible incluye bonos imponibles. Bonificaciones no imponibles (movilización,
  // colación, asignación familiar) NO se suman acá — entran como pagos separados.
  const totalImponible = sueldoBase + gratificacion + bonosFijo + bonosVariable;

  // AFP — capitalización individual (10% default) + comisión variable de la AFP.
  const capIndividual = Math.round(totalImponible * ((rem.afp_cap_individual_pct ?? 10) / 100));
  const comisionAfp = Math.round(totalImponible * ((rem.afp_comision_pct || 0) / 100));
  const totalAfp = capIndividual + comisionAfp;

  // Salud — Fonasa: 7% del imponible. Isapre: max(UF×valorUF, 7%) — el 7% es piso legal.
  let totalSalud = 0;
  if (rem.salud_tipo === "fonasa") {
    totalSalud = Math.round(totalImponible * 0.07);
  } else if (rem.salud_tipo === "isapre") {
    const ufCargo = rem.salud_isapre_uf && ufDelMes > 0 ? Math.round(Number(rem.salud_isapre_uf) * ufDelMes) : 0;
    const pisoLegal = Math.round(totalImponible * 0.07);
    totalSalud = Math.max(ufCargo, pisoLegal);
  }

  // Seguro cesantía trabajador (0.6% imponible).
  const segCesantia = Math.round(totalImponible * 0.006);

  // Base impuesto único = imponible - AFP - salud - cesantía (los 3 descuentos previsionales).
  const baseImpuesto = totalImponible - totalAfp - totalSalud - segCesantia;
  const impuestoUnico = calcularImpuestoUnico(baseImpuesto);

  const totalDescuentosLegales = totalAfp + totalSalud + segCesantia + impuestoUnico;
  const descVar = Number(descuentosVarios) || 0;
  const totalDescuentos = totalDescuentosLegales + descVar;
  const liquido = totalImponible - totalDescuentos;

  return {
    sueldoBase,
    gratificacion,
    bonosFijo,
    bonosVariable,
    totalImponible,
    capIndividual,
    comisionAfp,
    totalAfp,
    totalSalud,
    segCesantia,
    baseImpuesto,
    impuestoUnico,
    totalDescuentosLegales,
    descuentosVarios: descVar,
    totalDescuentos,
    liquido,
  };
};
